module.exports = __webpack_public_path__ + "img/gnu_main1.3ed7e48f.jpg";